import ODAS from '@/utils/api/odas';

const TopicPages = {
  fetchTopicPages: (region) => {
    const params = {
      region: region
    };
    return ODAS.get('/api/topic_pages', params);
  }
};

export default TopicPages;
